import React, { memo } from "react";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";

const CustomButton = memo(
  ({
    text,
    path,
    paddingX,
    isSelected,
    fullWidth = false,
    onClick,
    sx = {},
  }) => {
    const handleClick = () => {
      if (onClick) {
        onClick();
      }
    };

    return (
      <Button
        component={Link}
        to={path}
        onClick={handleClick}
        fullWidth={fullWidth}
        className={isSelected ? "navigation-button-selected" : "navigation-button"}
        variant={isSelected ? "contained" : "text"}
      >
        {text}
      </Button>
    );
  },
);

CustomButton.displayName = "CustomButton";

export default CustomButton;
